import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { systemAuditLogApi } from '../../../apis/SystemAuditLogApi/SystemAuditLogApi';
import { ISearchAuditLogsResult } from '../SystemAuditLog';

export function useRealtimeAuditLogs(
  enabled: boolean
): UseQueryResult<ISearchAuditLogsResult, Error> {
  return useQuery({
    queryKey: ['auditLogs', 'realtime'],
    queryFn: async () => {
      return systemAuditLogApi.searchAuditLogs({
        pageNumber: 1,
        pageSize: 50,
        sortBy: 'EventDate',
        sortDirection: 'DESC',
      });
    },
    refetchInterval: enabled ? 3000 : false,
    enabled,
  });
}
